import { useFormContext } from "react-hook-form";
import { useMemo } from "react";
import { FormControl, Input, InputLabel } from "@mui/material";
import daLiJePoljeValidno from "../../../../utils/daLiJePoljeValidno";
import { PorukaGreskePolja } from "../../../index";

const Index = () => {
  const { register, getValues } = useFormContext();
  const nazivPolja = useMemo(() => "opisOkolnosti", []);
  const value = getValues(nazivPolja);
  return (
    <>
      <FormControl
        fullWidth
        variant="outlined"
        error={!daLiJePoljeValidno(nazivPolja)}
      >
        <InputLabel htmlFor={nazivPolja}>Razlog isključenja:</InputLabel>
        <Input
          value={value || ""}
          multiline
          rows={4}
          {...register(nazivPolja)}
        />
      </FormControl>
      <PorukaGreskePolja nazivPolja={nazivPolja} />
    </>
  );
};

export default Index;
